<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ActionsSection',
  mounted() {
    this.SET_SECTION('Actions');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
